export default "__VITE_ASSET__C8HvAd8$__"